import { FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import BooleanToggle from 'components/forms/new/formikFormFields/BooleanToggle';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const SharedField = ({ darkMode, values, setFieldValue }) => (
    <FormControl sx={{ margin: '0 !important' }}>
        <Stack
            direction="row"
            alignItems="center"
            spacing={stackSpacing}
            sx={stackStyling()}>
            <FormLabel sx={formLabelStyling(darkMode, true)}>Shared</FormLabel>
            <Field
                name="shared"
                component={BooleanToggle}
                isChecked={values?.shared ?? false}
                onChange={(value) => setFieldValue('shared', value)}
            />
        </Stack>
    </FormControl>
);

export default SharedField;
